<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="form-group">
                    <label>Customer</label>
                    <div class="text-danger" v-if="customerGroupPricingDelivery.customerId.hasError">
                        {{customerGroupPricingDelivery.customerId.errorMessage}}
                    </div>
                    <bootstrap-select :selectOptions="companies" :selectedOption="customerGroupPricingDelivery.customerId.value" :elementId="'customerSelect'"
                                      :returnSelectedOptionText="true"
                                      @changeSelect="onCompanySelect"></bootstrap-select>
                </div>
                <div class="form-group">
                    <label>Product</label>
                    <div class="text-danger" v-if="customerGroupPricingDelivery.productId.hasError">
                        {{customerGroupPricingDelivery.productId.errorMessage}}
                    </div>
                    <bootstrap-select :selectOptions="products" :selectedOption="customerGroupPricingDelivery.productId.value" :elementId="'productSelect'"
                                      :returnSelectedOptionText="true"
                                      @changeSelect="onProductSelect"></bootstrap-select>
                </div>
                <div class="form-group">
                    <label>Zones Pricing</label>
                    <div class="text-danger">
                        {{customerGroupPricingDelivery.zoneErrorMessage}}
                    </div>
                    <zone-pricing-for-customer-add-update-table
                            :customerZonePricing="customerGroupPricingDelivery.zonePricing"
                            :companyId="customerGroupPricingDelivery.customerId.value"
                            :product="customerGroupPricingDelivery.selectedProduct"
                            :clearTable="clearZonePricingTable"
                            :orderTypeId="orderTypeId"
                            @zoneSelected="onZoneSelected"></zone-pricing-for-customer-add-update-table>
                </div>
                <div class="form-group">
                    <label>Effective Date</label>
                    <div class="text-danger" v-if="customerGroupPricingDelivery.effectiveDate.hasError">
                        {{customerGroupPricingDelivery.effectiveDate.errorMessage}}
                    </div>
                    <date-picker :format="'DD/MM/YYYY'" :elementId="'effectiveDateSelect'" :date="customerGroupPricingDelivery.effectiveDate.value"
                                 :initialiseDate="initialiseDate"
                                 @dateChange="onEffectiveDateSelect"></date-picker>
                </div>
                <button class="btn btn-primary mr-2" @click="saveDeliveryPricing" :disabled="loading">Save</button>
                <button class="btn btn-secondary" @click.prevent="onBackClick" :disabled="loading">Back</button>
            </div>
        </div>
    </div>

    <error-modal :modalHeading="errorModal.modalHeading"
                 :elementId="errorModal.elementId"
                 :modalMessage="errorModal.modalMessage"
                 :showModal="errorModal.showModal"
                 @okClicked="errorModalOkClicked"></error-modal>
    <success-modal
            :modalHeading="successModal.modalHeading"
            :elementId="successModal.elementId"
            :modalMessage="successModal.modalMessage"
            :showModal="successModal.showModal"
            @okClicked="successModalOkClicked">
    </success-modal>
</div>
